import React, { useState } from 'react';
import { Settings as SettingsIcon, List } from 'lucide-react';
import NotificationsList from './notifications/NotificationsList';
import NotificationPreferences from './NotificationPreferences';

// Simplificado 2026-09-18: se retiraron las sub-tabs "Estadísticas" y
// "Pruebas". Stats no aportaba nada sobre lo que ya muestra la campana; el
// panel de testing sólo era útil en dev y quedó expuesto en producción.

const NotificationsModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'list' | 'preferences'>('list');

  const tabs = [
    { id: 'list' as const, label: 'Todas las Notificaciones', icon: List },
    { id: 'preferences' as const, label: 'Preferencias', icon: SettingsIcon },
  ];

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Centro de Notificaciones</h1>
        <p className="text-gray-600">Historial y preferencias de notificaciones</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8 px-6">
            {tabs.map(tab => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </nav>
        </div>

        <div className="p-6">
          {activeTab === 'list' ? <NotificationsList /> : <NotificationPreferences />}
        </div>
      </div>
    </div>
  );
};

export default NotificationsModule;
